import { withStyles } from '@material-ui/core';

const styles = (theme) => ({
  value: {
    color: theme.TextColor,
    fontSize: theme.textFontSize
  },
  upperCase: {
    textTransform: 'uppercase'
  }
});
const Value = ({ value, classes, customClasses }) => (
  <div className={`${classes.value}  ${customClasses ? customClasses : ''}`}>{value ?? ""}</div>
);

export default withStyles(styles)(Value);
